import { Component } from '@angular/core';

@Component({
  selector: 'app-contacts-report',
  templateUrl: './contacts-report.component.html',
  styleUrls: ['./contacts-report.component.scss']
})
export class ContactsReportComponent {
 reports = [
    { name: 'Key Accounts', description: 'Accounts with more Deals', lastAccessed: 'Yesterday' },
    { name: 'Contact Mailing List', description: 'Contact Address details', lastAccessed: 'Yesterday' },
    { name: 'Accounts by Industry', description: 'Accounts by Industry', lastAccessed: 'Yesterday' }
  ];
}
